import store from "@/store";

const routes = [
  {
    path: "/it/stock-adjustment/:id",
    name: "itstockadjustment",
    component: () => import("@/views/main/modules/IT/StockAdjustmentGroupComponent.vue"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Stock Adjustment",
    },
  },
];

export default routes;
